import { useMemo } from 'react'

import { CompositeTableTemplate } from 'app/common/templates-next/table-template'

import {
  columnKeysLeft,
  columnKeysLeftHeaders,
  createColumnKeysMain,
  createColumnKeysMainHeaders,
  createData,
  createDataProps,
  createTdPropsByRowAndColumnKey,
  createHeaderCells,
  createHeaderCellsProps,
  renderTableCell,
} from './table-options'
import { ReportSubsidiesActData } from 'app/dataTypes/reports/data/common/subsidies/act'

type Props = {
  data: ReportSubsidiesActData
  pending: boolean
}


export const ReportTable = ({
  data,
  pending,
}: Props) => {
  const { rows } = data

  const tdPropsByRowAndColumnKey = useMemo(() => createTdPropsByRowAndColumnKey(), [])

  const tableData = useMemo(() => {
    const mainColumnKeys = createColumnKeysMain()
    const mainColumnKeysHeader = createColumnKeysMainHeaders()
    const headerCells = createHeaderCells()
    const headerCellsProps = createHeaderCellsProps()
    return {
      columnKeysLeft: columnKeysLeft,
      columnKeysLeftHeaders: columnKeysLeftHeaders,
      columnKeysMain: mainColumnKeys,
      columnKeysMainHeaders: mainColumnKeysHeader,
      header: headerCells,
      headerProps: headerCellsProps,
      data: createData(rows),
      dataProps: createDataProps(),
    }
  }, [rows])

  return (
    <CompositeTableTemplate
      data={tableData}
      loading={pending}
      renderCell={renderTableCell}
      tdPropsByRowAndColumnKey={tdPropsByRowAndColumnKey}
      borderTop
    />
  )
}
